import * as R from "ramda";

const formatNumber = value => {
  if (value % 1 !== 0) {
    return value.toLocaleString("pt-br");
  } else {
    return `${value.toLocaleString("pt-br")},00`;
  }
};

export const isBlank = R.anyPass([
  R.equals(null),
  R.equals(undefined),
  R.isEmpty
]);

export const defaultIfBlank = R.uncurryN(2, v => R.when(isBlank, R.always(v)));

export const centsToReal = value =>
  value ? formatNumber(value / 100) : "0,00";

export const timedIdentity = seconds => obj => [
  parseInt(+new Date() / (1000 * seconds), 10),
  obj
];

export const filteredTreeDataFromFlatData = (
  flatData,
  itemKey,
  parentKey,
  filter = () => {},
  key = null
) => {
  return flatData
    .filter(item => item[parentKey] === key && filter(item))
    .map(item => ({
      item,
      children: filteredTreeDataFromFlatData(
        flatData,
        itemKey,
        parentKey,
        filter,
        item[itemKey]
      )
    }));
};

export const flatDataFromTreeData = treeData => {
  const reduceFn = (flatData, branch) => [
    ...flatData,
    branch.item,
    ...flatDataFromTreeData(branch.children)
  ];
  return treeData.reduce(reduceFn, []);
};

export const formatToMask = (mask, word) => {
  let test = "" + word;
  let result = "";

  for (let i = 0, wrd = 0; i < mask.length && wrd < test.length; i++) {
    result += mask[i] === "X" ? test.charAt(wrd++) : mask.charAt(i);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/util/functions.js